export enum EntryClass {
    Event = 0,
    Note = 1,
    File = 2,
}
